export default [
  {
    path: '/settings/ticket-categories',
    name: 'ticket-category-list',
    component: () => import('@/views/settings/TicketCategories.vue'),
    meta: {
      pageTitle: 'Catégories de tickets',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'repository-list' } },
        { text: 'Catégories de tickets', active: true },
      ],
      requiresAdmin: true,
    },
  },
]
